export interface defaultStateInterface {
  miloUpdatedInfo: {
    [contactId: string]: {
      updatedToMilo: boolean
    }
  },
  caseNotesEligibility: {
    [contactId: string]: {
      eligible: boolean
    }
  }
}

const defaultState: defaultStateInterface = {
  miloUpdatedInfo: {},
  caseNotesEligibility: {}
}

const caseNotesReducer = (state: defaultStateInterface = defaultState, action: any) => {
  const miloUpdatedInfoCopy = { ...state.miloUpdatedInfo }
  switch (action.type) {
    case 'SET_MILO_UPDATED':
      const { contactId, updatedToMilo } = action.payload
      miloUpdatedInfoCopy[contactId] = { updatedToMilo }
      return {...state, miloUpdatedInfo: miloUpdatedInfoCopy }

    case 'SET_CASE_NOTES_ELIGIBLE':
      const { eligible = false, contactId: contactIdPayload = ''} = action.payload
      if(contactIdPayload === '') {return state}
      return { ...state, caseNotesEligibility: { ...state.caseNotesEligibility, [contactIdPayload]: { eligible} } }

    default:
      return state
  }
}

export default caseNotesReducer
